export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="sheet">
        <p className="eyebrow mono">Drawings / Calculations / Know-how — EngiMind</p>
        <h1>
          <span className="line">図面・計算・ノウハウの属人化を、</span>
          <br />
          <span className="line">ソフトウェアとAIで<span className="accent">解消</span>。</span>
        </h1>
        <div className="hero-grid">
          <div>
            <p className="lead">
              紙のまま眠る図面、ベテランのExcel計算表、人に付いた判断基準を、誰でも安全に使えるソフトウェアに変えます。
              製造業で工程を立ち上げ、設計計算プログラムを作ってきたエンジニアが、
              製造業・建設業の課題ヒアリングから開発・導入まで一人で一貫対応します。
            </p>
            <div className="cta-row">
              <button className="btn-primary" onClick={scrollToContact}>無料相談を申し込む</button>
              <span className="cta-note">初回ヒアリング無料／オンライン可</span>
            </div>
          </div>
          <figure className="calc-card mono" aria-label="設計計算書のサンプル">
            <div className="calc-head">
              <span className="calc-title serif">梁のたわみ計算書</span>
              <span className="calc-no">CALC-001 / Rev.2</span>
            </div>
            <div className="calc-rows">
              <div className="row"><span className="k">支持条件</span><span>両端単純支持・中央集中荷重</span></div>
              <div className="row"><span className="k">スパン L</span><span>1,200 mm</span></div>
              <div className="row"><span className="k">荷重 P</span><span>8.5 kN</span></div>
              <div className="row"><span className="k">ヤング率 E</span><span>205,000 N/mm²</span></div>
              <div className="row"><span className="k">断面二次モーメント I</span><span>4.72×10⁶ mm⁴</span></div>
              <div className="row"><span className="k">たわみ δ = PL³/48EI</span><span>0.316 mm</span></div>
            </div>
            <div className="calc-result">
              <span>判定：δ/L = 1/3,800 ≦ 1/1,000</span>
              <span className="hanko" aria-label="判定 適">適</span>
            </div>
            <figcaption className="calc-caption">※ この計算がボタン一つで、誰でも、根拠付きで。</figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}
